import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import FreedomIcon from '@/components/Icon/FreedomIcon'
import api from './utils/api';
import wx from 'weixin-js-sdk';
import './assets/less/base.less';

Vue.config.productionTip = false;

// if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'sit' ) {
//   // eslint-disable-next-line no-unused-vars
//   const vConsole = new VConsole();
// }

//order/sign/validate?sign=5FF1B8DA152D932AA11473E57EF8E340B12C74011526FE1FF48DC352FAFBA879

//const vConsole = new VConsole();
Vue.prototype.$wechat = wx;
Vue.wechat = wx;

Vue.prototype.$http = api;

Vue.component('FreedomIcon', FreedomIcon);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
